<template>
    <form-row title="MLS #">
        <div class="sm:col-gap-2 flex-1 mb-2 sm:-mt-4">
            <input-text
                label="Listing Number"
                name="listing_mls"
                :value="deal.listing_mls"
                placeholder="#"
                :read_only="read_only"
            />
        </div>

        <div class="sm:col-gap-2 flex-1 mb-2 sm:-mt-4">
            <input-text
                label="Sale Number"
                name="purchase_mls"
                :value="deal.purchase_mls"
                placeholder="#"
                :read_only="read_only"
            />
        </div>
    </form-row>
</template>

<script>
export default {
    props: {
        deal: { default: () => ({}) },
        read_only: { default: false },
    },
}
</script>
